<div class="page-content bg-light">
    <section class="p-5 account-wrapper">
        <div class="confirmation-card account-card">
            <div class="text-center mt-4 d-flex flex-column align-items-center">
                <h2 class="mb-3 text-capitalize">Your Order Is Completed !</h2>
                <img src="https://pixio.dexignzone.com/xhtml/images/confirmation.png" width="200px" class="mb-3"
                    alt="Confirmation Image">

                <h4 class="mb-2">
                    You will receive an order confirmation email with details of your order.
                </h4>
                <div *ngIf="isLoading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading order details...</p>
                </div>
                <div *ngIf="hasError && !isLoading" class="alert alert-danger mt-3" role="alert">
                    {{ errorMessage }}
                </div>
                <div *ngIf="orderDetails && !isLoading" class="mt-3">
                    <p class="mb-2">Order ID: <strong>{{ orderDetails.id }}</strong></p>
                    <p class="mb-0">Order Date: {{ orderDetails.created_at | date:'mediumDate' }}</p>
                    <h5 class="mt-4 mb-2">Order Summary</h5>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <table class="table table-bordered mt-3 text-black">
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>Quantity</th>
                                        <th class="text-end">Price</th>
                                        <th class="text-end">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of orderDetails.order_items">
                                        <td>{{ item.product_name }}</td>
                                        <td>{{ item.quantity }}</td>
                                        <td class="text-end">&#8377;{{ item.price_at_order | number:'1.2-2' }}</td>
                                        <td class="text-end">&#8377;{{ item.total | number:'1.2-2' }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="3" class="text-end">Subtotal:</th>
                                        <td class="text-end">&#8377;{{ orderDetails.subtotal | number:'1.2-2' }}</td>
                                    </tr>
                                    <tr *ngIf="orderDetails.coupon_discount > 0">
                                        <th colspan="3" class="text-end text-success">Coupon Discount:</th>
                                        <td class="text-end text-success">- &#8377;{{ orderDetails.coupon_discount |
                                            number:'1.2-2' }}</td>
                                    </tr>
                                    <tr>
                                        <th colspan="3" class="text-end">Delivery Charge:</th>
                                        <td class="text-end">&#8377;{{ orderDetails.delivery_charge | number:'1.2-2' }}
                                        </td>
                                    </tr>
                                    <tr class="fw-bold">
                                        <th colspan="3" class="text-end">Grand Total:</th>
                                        <td class="text-end">&#8377;{{ orderDetails.final_total | number:'1.2-2' }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <p class="mt-4">For tracking your order status, please <a [routerLink]="['/login']">login here</a>
                        and view your order history.</p>
                </div>
                <div class="mt-4 d-sm-flex gap-3 justify-content-center">
                    <a href="dashboard" class="btn my-1 btn-secondary">Track Order</a>
                    <a href="home" class="btn btn-outline-secondary my-1 btnhover20">Back To Home</a>
                </div>
            </div>
        </div>
    </section>
</div>